<template>
  <div class="container has-text-centered">
    <div class="column is-4 is-offset-4">
      <b-field>
        <b-button type="is-danger" size="is-medium" expanded @click="onLogout">{{ $t('message.logout') }}</b-button>
      </b-field>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  methods: {
    onLogout() {
      axios.post(`/api/v1/cie/logout/${localStorage.getItem('cie_code')}`)
      localStorage.removeItem('cie_code')
      this.$emit('updateCie')
      localStorage.removeItem('cie_lang')
      this.$i18n.locale = this.getLocale()
      this.$router.push({path: '/ui/cie'})
    }
  }
}
</script>
